import Field from '@/ecm/models/document/Field'

export default class Document {
    constructor(dto) {
        this.id = 0
        this.contentType = null
        this.fields = []
        this.hasAutomaticRecognition = false

        if (dto) {
            this.id = parseInt(dto.ObjectID)
            this.contentType = { id: dto.ContentTypeID + '', text: dto.ContentType }
            this.fields = dto.Fields.map(function (fieldDto) { return new Field(fieldDto, dto.Fields) })
            this.hasAutomaticRecognition = dto.HasAutomaticRecognition
        }
    }

    toDto(attachments, isNewValueFormat = false) {
        return {
            ObjectID: this.id,
            ContentTypeID: this.contentType.id,
            HasAutomaticRecognition: this.hasAutomaticRecognition,
            Fields: this.fields.map(function (f) {
                var value = Array.isArray(f.value) ? f.value.filter(x => x).join(',') : f.value
                return {
                    Title: f.title,
                    Code: f.code,
                    Value: value,
                    IsNewValueFormat: isNewValueFormat,
                    ValueString : value,
                    ValueDate : f.valueDate,
                    ValueNumber : f.valueNumber,
                    Type : f.type
                }
            }),
            Attachments: attachments.map(function (f) {
                return {
                    Id: f.id,
                    FileName: f.fileName,
                    FileID: f.fileId,
                }
            }),
        }
    }
}
